// extracted by mini-css-extract-plugin
module.exports = {"ImageWithLabel":"styles_ImageWithLabel__jKQDs","image":"styles_image__8TMZJ","label":"styles_label__68sUM","ratio":"styles_ratio__X_Jq0"};